<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
                <!-- <div class="modal__logo-title">Seguro Desk</div> -->
            </div>

            <div class="modal__main-icon modal__main-icon--password"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <div class="navigators">
                    <div class="navigator navigator--active">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">{{ $t(`changePasswordModal.${"title"}`) }}</div>
                    </div>
                </div>
                <div class="add__form ">
                    <transition name="fade" mode="out-in">

                        <div class="add__content">
                            <div class="form__field">
                                <input type="password" class="input input--default"
                                    :class="{ 'input--error': currentPassHasError }"
                                    :placeholder="$t(`changePasswordModal.${'passPlaceholder'}`)"
                                    v-model="currentPass" />
                                <div class="form__error" v-if="currentPassHasError">
                                    {{ $t(`changePasswordModal.${"requiredMsg"}`) }}
                                </div>
                            </div>

                            <div class="form__field">
                                <input type="password" class="input input--default"
                                    :class="{ 'input--error': newPassHasError || newPassLengthError }"
                                    :placeholder="$t(`changePasswordModal.${'newPassPlaceholder'}`)"
                                    v-model="newPass" />
                                <div class="form__error" v-if="newPassHasError">
                                    {{ $t(`changePasswordModal.${"requiredMsg"}`) }}
                                </div><br>
                                <div class="form__error" v-if="newPassLengthError">
                                    {{ $t(`changePasswordModal.${"lengthMsg"}`) }}
                                </div>

                            </div>

                            <div class="form__field">
                                <input type="password" class="input input--default"
                                    :class="{ 'input--error': confirmPassHasError || confirmPassMismatchError }"
                                    :placeholder="$t(`changePasswordModal.${'confirmPassPlaceholder'}`)"
                                    v-model="confirmPass" />
                                <div class="form__error" v-if="confirmPassHasError">
                                    {{ $t(`changePasswordModal.${"requiredMsg"}`) }}
                                </div><br>
                                <div class="form__error" v-if="confirmPassMismatchError">
                                    {{ $t(`changePasswordModal.${"mismatchMsg"}`) }}
                                </div>
                            </div>

                        </div>
                    </transition>
                </div>
            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>
            <button v-else class="modal__button modal__button--submit button button--default" @click="updatePassword()">
                <span>{{ $t(`changePasswordModal.${"saveBtn"}`) }}</span>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n';   

// eslint-disable-next-line no-unused-vars
const { t } = useI18n();

defineOptions({
    name: "ChangePassword"
});

const store = useStore();

// State
const isRequesting = ref(false);
const currentPass = ref('');
const newPass = ref('');
const confirmPass = ref('');

const currentPassHasError = ref(false);
const newPassHasError = ref(false);
const confirmPassHasError = ref(false);
const newPassLengthError = ref(false);
const confirmPassMismatchError = ref(false);

// Validation Logic
const validateCurrentPass = () => {
    currentPassHasError.value = !currentPass.value;
};

const validateNewPass = () => {
    if (newPass.value) {
        if (newPass.value.length < 8) {
            newPassHasError.value = false;
            newPassLengthError.value = true;
        } else {
            newPassHasError.value = false;
            newPassLengthError.value = false;
        }
    } else {
        newPassHasError.value = true;
        newPassLengthError.value = false;
    }
};

const validateConfirmPass = () => {
    if (confirmPass.value) {
        if (confirmPass.value !== newPass.value) {
            confirmPassHasError.value = false;
            confirmPassMismatchError.value = true;
        } else {
            confirmPassHasError.value = false;
            confirmPassMismatchError.value = false;
        }
    } else {
        confirmPassHasError.value = true;
        confirmPassMismatchError.value = false;
    }
};

// Watchers
watch(currentPass, validateCurrentPass);
watch(newPass, validateNewPass);
watch(confirmPass, validateConfirmPass);

// Lifecycle
onUnmounted(() => {
    store.commit("setShowChangePasswordModal", false);
});

// Methods
const closeModal = () => {
    store.commit("setShowChangePasswordModal", false);
};

const updatePassword = async () => {
    validateCurrentPass();
    validateNewPass();
    validateConfirmPass();

    if (!currentPassHasError.value && !newPassHasError.value && !confirmPassHasError.value) {
        isRequesting.value = true;
        try {
            await store.dispatch("updatePassword", {
                current_password: currentPass.value,
                password: newPass.value,
                password_confirmation: confirmPass.value
            });

            store.commit("setToast", {
                display: true,
                type: "success",
                message: t("messages.passwordUpdatedSuccessfully"),
            });

            isRequesting.value = false;
            store.commit("setShowChangePasswordModal", false);
        } catch (err) {
            let errorMessages = ["Unable to update password."];

            if (err.response?.data?.errors) {
                errorMessages = Object.values(err.response.data.errors).flat();
            } else if (err.response?.data?.message) {
                errorMessages = [err.response.data.message];
            }

            errorMessages.forEach((msg) => {
                store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: msg,
                });
            });
            isRequesting.value = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.form__field {
    width: 40%;
    margin: 30px auto;
}

.add__form {
    width: 100% !important;
}
</style>
